import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { IGetMfaSessionAllIssuesParams } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { getMfaSessionAllIssues } from 'src/apps/mfa/services/MfaSingleSessionService';
import { TMfaSessionAllIssuesResult } from 'src/apps/mfa/types/MfaDashboardServiceTypes';
import { MFA_SESSION_ALL_ISSUES } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { IUseTableQueryParams } from 'src/common/types/UseTableQueryParamsType';

interface IUseMfaSessionAllIssuesQueryParams extends IUseTableQueryParams {
	sessionId: string;
}

export const useMfaSessionAllIssuesQuery = ({
	sessionId,
	filters,
	sort,
	page,
	pageSize
}: IUseMfaSessionAllIssuesQueryParams): UseQueryResult<TMfaSessionAllIssuesResult> => {
	const issuesQuery = useQuery(
		[MFA_SESSION_ALL_ISSUES, sessionId, filters, sort, page, pageSize],
		async (): Promise<TMfaSessionAllIssuesResult> =>
			getMfaSessionAllIssues({
				sessionId,
				filterOptions: filters as IGetMfaSessionAllIssuesParams['filterOptions'],
				sort,
				page,
				pageSize
			}),
		{
			refetchOnWindowFocus: 'always'
		}
	);

	return issuesQuery;
};
